import type { InventoryStockTransaction } from '../types/inventory';
import { userDisplayNameOr } from './userDisplayName';

// Fase 22C-1: texto del origen de un movimiento del Kardex. Extraído del componente para poder
// probarlo sin renderizador. Para Ventas Otros muestra "Venta Otros · VO-…" / "Anulación Venta Otros ·
// VO-…" usando el folio ya formateado por el backend — nunca un UUID como referencia principal.
export function movementOrigin(item: Pick<InventoryStockTransaction, 'sourceType' | 'sourceOtherSaleFolio' | 'createdByUser'> & { type?: InventoryStockTransaction['type'] }): string {
  // F1: la anulación de una merma también es MANUAL, pero dice qué es y quién la anuló.
  if (item.type === 'WASTE_OUT_REVERSAL') return `Origen: anulación de merma · ${userDisplayNameOr(item.createdByUser)}`;
  if (item.sourceType === 'OTHER_SALE') return `Venta${item.sourceOtherSaleFolio ? ` · ${item.sourceOtherSaleFolio}` : ''}`;
  if (item.sourceType === 'OTHER_SALE_REVERSAL') return `Anulación de venta${item.sourceOtherSaleFolio ? ` · ${item.sourceOtherSaleFolio}` : ''}`;
  if (item.sourceType === 'PURCHASE') return 'Origen: compra';
  if (item.sourceType === 'PURCHASE_REVERSAL') return 'Origen: anulación de compra';
  if (item.sourceType === 'TRANSFER') return 'Origen: traspaso';
  if (item.sourceType === 'SALES_RECEIPT') return 'Origen: venta';
  if (item.sourceType === 'SALES_REVERSAL') return 'Origen: reversa de venta';
  // F3: ajustes y merma detectada al contar; dice quién contó.
  if (item.sourceType === 'PHYSICAL_COUNT') return `Origen: conteo físico · ${userDisplayNameOr(item.createdByUser)}`;
  return `Origen: manual · ${userDisplayNameOr(item.createdByUser)}`;
}
